import { useAuth } from "../../hooks/Auth"
import message from "../../services/message"
import Header from "./Header"
import Sidebar from "./Sidebar"
import {ContainerLayout} from "./styles"
import { IconAtendimento, IconAtribuir, IconEnderecos, IconIntegracoes, IconLogout, IconPonto, IconPriorizar, IconResumo, IconUsuarios, IconVeiculos } from "./Svgs"

const Layout: React.FC = (props) => {
    

    return (
        <ContainerLayout>
            
            <Header />
            
            <Sidebar />

            <div className="content">
                { 
                    props.children
                }
            </div>
        </ContainerLayout>
    )
}

export default Layout